import { useSize } from '../modules/size/composables/useSize';
import { useColor } from '../modules/color/composables/useColor';
import { useType } from '../modules/type/composables/useType';

/**
 *
 * @param {import('@vueuse/core').MaybeRef<string>} id
 */
export function useTraits(id) {
  const { selectedColor, selectedColorId } = useColor(id);
  const { selectedSize, selectedSizeId } = useSize(id);
  const { selectedTypeId, selectedType } = useType(id);

  return {
    selectedColor,
    selectedSize,
    selectedType,
    selectedColorId,
    selectedSizeId,
    selectedTypeId,
  };
}

export default useTraits;
